import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";
import { useRouter } from "vue-router";
import { getUserSession } from "@/business/auth/application/getUserSession";

export const tokenValidation = {
  async execute(): Promise<string> {
    const userAuth = getUserSession.execute();

    const router = useRouter();
    if (
      userAuth == null ||
      userAuth.token == null ||
      userAuth.token.length <= 0
    ) {
      await router.push("/login");
      throw DaccachErrorActions().createError("Usuario no Autenticado");
    }

    return userAuth.username + "|" + userAuth.token;
  },
};
